class CompanyConfig {
  static Company_Endpoints = (id) => ({
    list: 'companies',
    details: `companies/${id}`,
    add: `companies/${id}`,
    lookup: 'companies/lookups',
    modules: 'modules',
    lastTenant: 'tenants/last',
    fabsTenants: 'tenants/fabs',
    ssoAddCompanyConfig: `companies/${id}/saml/config`,
  })
}
export default CompanyConfig
